// Don't use values that aren't defined in libs/theme/src/lib/sass/_elevation.scss
export enum ELEVATION {
  Z_INDEX_0 = 0,
  Z_INDEX_99 = 99,
  Z_INDEX_1010 = 1010,
  Z_INDEX_TOAST = 999999
}
